import api from '@/services/api';
const ENTITY_ENDPOINT = 'reportes';

export class ReporteService {
  /**
   * Obtiene todos los reportes con filtros y paginación
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }

  /**
   * Obtiene un reporte por su ID
   * @param {string|number} id - ID del reporte
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findById(id) {
    return await api.get(`/${ENTITY_ENDPOINT}/${id}`);
  }

  /**
   * Genera un reporte por nombre
   * @param {string} reportName - Nombre del reporte
   * @param {Object} filters - Filtros para el reporte
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async generateReport(reportName, filters) {
    return await api.post(`/${ENTITY_ENDPOINT}/${reportName}`, filters, { timeout: 30000 });
  }

  /**
   * Genera un reporte por nombre
   * @param {string} reportName - Nombre del reporte
   * @param {Object} filters - Filtros para el reporte
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async generateReportWithCriteria(reportName, filters) {
    return await api.get(`/${ENTITY_ENDPOINT}/${reportName}/criteria?${filters}`);
  }

  /**
   * Obtiene los datos de un reporte por nombre
   * @param {string} reportName - Nombre del reporte
   * @param {Object} filters - Filtros para el reporte
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async getReportData(reportName, filters) {
    return await api.post(`/${ENTITY_ENDPOINT}/${reportName}/data`, filters, { timeout: 30000 });
  }
}

export default ReporteService;
